// extracted by mini-css-extract-plugin
module.exports = {"background":"aTGQE","confirm":"_0tpK+","dialogue":"S5Ls4"};